<template>
    <PopoverRight ref="popoverMenu" width="800px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">动态生成记录</h1>
            <div class="cnt-area">
                <el-table
                    :data="recordList"
                    style="width: 100%"
                    :highlight-current-row="true"
                    stripe
                    tooltip-effect="dark"
                    ref="multipleTable"
                    header-cell-class-name="table-back"
                    class="list-table"
            >
                <el-table-column  label="操作时间" prop="created_at" width="160" align="center"></el-table-column>
                <el-table-column  label="操作人" prop="operator" align="center"></el-table-column>
                <el-table-column  label="生成方式" prop="type" align="center">
                    <template slot-scope="scope">
                        <span class="ellipse">{{scope.row.type == "1"?"指定站点生成":"指定楼盘生成"}}</span>
                    </template>
                </el-table-column>
                <el-table-column  label="站点" prop="site_names"  align="center">
                    <template slot-scope="scope">
                        <span class="ellipse" :title="scope.row.site_names">{{scope.row.site_names}}</span>
                    </template>
                </el-table-column>
                <el-table-column  label="状态" prop="success_count"  align="center">
                    <template slot-scope="scope">
                        {{("成功:"+scope.row.success_count+",失败:"+scope.row.error_count+",未完成:"+scope.row.wait_count)}}
                    </template>
                </el-table-column>
                <el-table-column label="操作"  fixed="right"  align="center" width="120">
                    <template slot-scope="scope">
                        <el-button  size="mini" @click="checkDetail(scope.row.id)"
                            >查看明细</el-button>
                    </template>
                </el-table-column>
            </el-table>
                <template v-if="recordList.length > 0">
                    <el-pagination
                        background
                        layout="total,prev, pager, next"
                        :current-page="condition.page"
                        :total="condition.total"
                        :page-size="condition.per_page"
                        @current-change="currentChange"
                    ></el-pagination>
                </template>
            </div>
                
            <div class="form-button" style="margin-left:20%;">
                <el-button type="info" @click.stop.prevent="hide">关闭</el-button>
            </div>
        </div>
        <record-detail ref="recordDetail" @hide="hide"></record-detail>
    </PopoverRight>

</template>

<script>
    import {dynamiTrendTplRecords} from '@/service/dynamicModel'

    import PopoverRight from '@/components/popoverRight/index'
    import recordDetail from "./recordDetail";

    export default {
        name: "record",
        components: {
            PopoverRight,
            recordDetail
        },
        data () {
         
            return {
               condition:{
                    template_id:'',
                    total: 0,
                    per_page: 10,
                    page: 1,
               },
               recordList:[],
            }
        },
        mounted(){
            
        },
        methods : {
            open (id) {
                this.condition.template_id = id
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
                this.getRecordList();
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.keyword='';
                this.title='';
                this.checkList=[];
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
            },
            async getRecordList(){
                await dynamiTrendTplRecords(this.condition).then((data) => {
                    this.recordList = data.data;
                    this.condition.total = data.total;
                })     
            },
            currentChange(index) {
                this.condition.page = index;
                this.getRecordList();
            },
            checkDetail(id){
                 this.$refs.recordDetail
                && this.$refs.recordDetail.open(id);
            },
        },
    }
</script>

<style scoped>
    .cnt-area{
        margin-top:40px;
    }
    .list-table{
        border:1px solid #EBEEF5;
        padding:0;
    }
    .ellipse{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .v-modal{
        z-index: 2000!important;
    }
</style>
